// Port of api/fuel/app/classes/controller/api/monty/custom/nesting/add.php
import DB from 'offline/db'
import Constants from 'offline/constants'
import Collection from 'offline/model/collection'
import { currentUser, persist, unauthorised, touchUser } from '../shared'

export default function(params) {
	var user = currentUser(params)
	if (!user) return unauthorised()

	var collectionId = parseInt(params.id, 10) || 0
	var parentId = parseInt(params.parent, 10) || 0

	var child = Collection.record({
		where: {
			user_id: user.get_id(),
			collection_id: collectionId
		}
	})

	var parent = Collection.record({
		where: [
			['user_id', '=', user.get_id()],
			['collection_id', '=', parentId],
			['collection_id', '<>', collectionId],
			['collection_nested', '=', 0]
		]
	})

	if (!child || !parent) return unauthorised()

	DB.run('UPDATE collection SET collection_nested = ?, collection_nested_custom = ? WHERE collection_id = ?', [
		parent.get_id() === child.get_nested_official() ? Constants.NESTED_OFFICIAL : Constants.NESTED_CUSTOM,
		parent.get_id() === child.get_nested_official() ? 0 : parent.get_id(),
		child.get_id()
	])

	touchUser(user)
	return persist({})
}
